import { INGREDIENTS_TREE_RDB } from '__constants__'
import database from 'services/firebase/database'
import { get, ref as databaseRef } from 'firebase/database'

/**
 * Retrieves the node tree from Firebase.
 * @returns {Promise<any>} A promise that resolves with the node tree.
 */
const getNodeTree = async () => {
  const snapshot = await get(databaseRef(database, INGREDIENTS_TREE_RDB))

  return snapshot.val()
}

export default getNodeTree
